export const GET_FLIGHT_WEATHER_START = '@flightWeather/GET_FLIGHT_WEATHER_START'
export const GET_FLIGHT_WEATHER_SUCCESS = '@flightWeather/GET_FLIGHT_WEATHER_SUCCESS'
export const GET_FLIGHT_WEATHER_FAILURE = '@flightWeather/GET_FLIGHT_WEATHER_FAILURE'

export const RESET_FLIGHT_WEATHER = '@flightWeather/RESET_FLIGHT_WEATHER'



// WEBPACK FOOTER //
// ./src/screens/briefing/weather/actions/types.js